<modal-popup [flexible]="true" [focusOnOpen]="focusOnOpen" [isOpen]="true" (onClose)="close()"
[alignLeft]="true" [cssClass]="detailsDialogClass"
[isLoading]="claimToolComponent?.first ? claimToolComponent.first.isLoading : loading"
  [title]="'translate.general.revRuleDetails'" [afterTitle]="claimToolComponent?.first ? claimToolComponent.first.headerActions : dirtyBtns" [footerTemplate]="claimToolComponent?.first ? null : footer">
  <info-details drawer [details]="drawerDetails"
    [isExpanded]="isExpanded"
    [label]="detailsDialogLabel"
    ></info-details>
  <claim-tool *ngIf="showClaimToolDialog" #claimTool [presentation]="'embedded'"
    [claim]="claimToolElement" (showDetailsDialogEmitter)="returnToDetailsFromClaimTool()"
    (saved)="onClaimToolSaved()" (onClose)="returnToDetailsFromClaimTool()"></claim-tool>
  <div *ngIf="curRule && !showClaimToolDialog">
    
    <div [ngClass]="{ 'phrase-rev-rule-container': isExpanded }">
      <div class="l-align-spaceBetween">
        <h3 *ngIf="curRule.similarityCode !== 'MISSING'">
          {{ "translate.general.workingPhrase" | translate }}
        </h3>
        <h3 *ngIf="curRule.similarityCode == 'MISSING'">
          {{ "translate.rev.missing" | translate }}:
        </h3>
        <p *ngIf="getMatchStatusCode()" [ngClass]="['rev-rule-status', getMatchStatusCode()]">
          {{ getMatchStatusDescr() }}
        </p>
        <spinner *ngIf="!curRule.revStatusCode" class="rev-rule-status-spinner"></spinner>
      </div>

      <div *ngIf="ruleCatMatches.length == 0 && isExpanded"></div>

      <div *ngIf="ruleCatMatches.length > 0 && isExpanded" class="phrase-rev-rule-navigation">
        <div class="phrase-rev-rule-nav-button-continer">
          <button *ngIf="!curRule.contextCatPhraseId" (click)="prevMatch()" class="phrase-rev-rule-nav-button phrase-rev-rule-nav-button-left">
            <i class="fas fa-arrow-left"></i>
            &nbsp;{{ (currentIndex === 0 ? 'translate.cat.last' : "translate.cat.prev") | translate }}
          </button>
        </div>

        <div class="phrase-rev-rule-current">
          <span>{{ (curRule.contextCatPhraseId ? 'translate.rev.selectedMatch' : 'translate.rev.currentMatch') | translate }}</span>
          <span *ngIf="!curRule.contextCatPhraseId">&nbsp;{{ 'translate.cat.position' | translate: {position: currentIndex + 1, totalCount: ruleCatMatches.length} }}</span>
        </div>

        <div class="phrase-rev-rule-nav-button-continer">
          <button *ngIf="!curRule.contextCatPhraseId" (click)="nextMatch()" class="phrase-rev-rule-nav-button phrase-rev-rule-nav-button-right">
            &nbsp;{{ (currentIndex === ruleCatMatches.length - 1 ? "translate.cat.first" : "translate.cat.next") | translate }}
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <div class="phrase-rev-rule-phrase-txt">
        <div style="display: flex; flex-direction: row;">
      
          <p class="phrase-txt">
            <formatted-phrase [phraseWords]="curRule.ruleDispWords" [grammarSpellingIssues]="curRule.grammarSpellingIssues"
              (onAddToWhitelist)="addToWhitelist($event)" [referenceIssues]="curRule.referenceIssues"></formatted-phrase>
          </p>
          <div>
            <i *ngIf="editable" class="fas fa-file-invoice icon-edit" (click)="showClaimTool()"
              [tooltip]="(curRule?.revRuleContentType === 'TEXT_CONTENT' ? 'translate.text.tool' : 'translate.claim.tool') | translate"></i>
          </div>
        </div>
      <ng-container *ngIf="curRule.consistencyIssues && curRule.consistencyIssues.length > 0">
        <div style="display:flex; margin-top: 10px; margin-right: 5px">
          <span style="margin-right: 5px" class="circle-badge error">{{ curRule.consistencyIssues.length }}</span>
          <a class="phrase-rev-rule-ref-title" (click)="hideClaimConsistenciesTable = !hideClaimConsistenciesTable">
             {{ "translate.general.consistencyIssues" | translate }}
            <span [ngClass]="hideClaimConsistenciesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
          </a>
        </div>
        <div></div>
      <slide-in-out *ngIf="!hideClaimConsistenciesTable" [isOpen]="!hideClaimConsistenciesTable">
        <div class="phrase-rev-rule-ref-container" style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
          <consistency-issues [consistencyIssues]="curRule.consistencyIssues"
              [element]="curRule"
              [disableActions]="conditionForDisablingConsistencyCheckResultActions"
              (viewConsistencyIssueEmitter)="viewConsistencyIssue($event)"
              (removeConsistencyIssueEmitter)="removeIssueEvent()"
              (markConsistencyIssueAsConsistent)="removeIssueEvent()"
              >

        </consistency-issues>
        <p style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
          <ai-icon></ai-icon>
        </p>
        </div>
      </slide-in-out>
      <div *ngIf="!hideClaimConsistenciesTable"></div>
      </ng-container>

      <ng-container *ngIf="curRule.fairBalanceIssues && curRule.fairBalanceIssues.length > 0">

              <div style="display:flex; margin-top: 10px; margin-right: 5px;">
                <span style="margin-right: 5px" class="circle-badge error">{{ curRule.fairBalanceIssues.length }} </span>
                <a class="phrase-rev-rule-ref-title" (click)="hideFairBalanceIssuesTable = !hideFairBalanceIssuesTable">
                  {{ "translate.general.fairBalanceIssues" | translate}}
                  <span [ngClass]="hideFairBalanceIssuesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
              <div></div>
          <slide-in-out *ngIf="!hideFairBalanceIssuesTable" [isOpen]="!hideFairBalanceIssuesTable">
            <div class="cat-phrase-ref-container" style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
              <fair-balance-issues [fairBalanceIssues]="curRule.fairBalanceIssues"
              [phrase]="curRule"
              [disableActions]="conditionForDisablingConsistencyCheckResultActions"
              (removeFairBalanceIssueEvent)="removeIssueEvent($event)"
              (viewFairBalanceIssueEvent)="viewFairBalanceIssue($event)"
              >
              </fair-balance-issues>
              <p style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                <ai-icon></ai-icon>
              </p>
            </div>
          </slide-in-out>
          <div *ngIf="!hideFairBalanceIssuesTable"></div>
      </ng-container>
      <ng-container *ngIf="curRule.complianceIssues && curRule.complianceIssues.length > 0">

              <div style="display:flex; margin-top: 10px; margin-right: 5px;">
                <span style="margin-right: 5px" class="circle-badge error">{{ curRule.complianceIssues.length }} </span>
                <a class="phrase-rev-rule-ref-title" (click)="hideComplianceIssuesTable = !hideComplianceIssuesTable">
                  {{ "translate.general.complianceIssues" | translate}}
                  <span [ngClass]="hideComplianceIssuesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
              <div></div>
          <slide-in-out *ngIf="!hideComplianceIssuesTable" [isOpen]="!hideComplianceIssuesTable">
            <div class="cat-phrase-ref-container" style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
              <compliance-issues [complianceIssues]="curRule.complianceIssues"
              [phrase]="curRule"
              [disableActions]="conditionForDisablingConsistencyCheckResultActions"
              (removeComplianceIssueEmitter)="removeIssueEvent($event)"
              >
              </compliance-issues>
              <p style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                <ai-icon></ai-icon>
              </p>
            </div>
          </slide-in-out>
          <div *ngIf="!hideComplianceIssuesTable"></div>
      </ng-container>
      <!--
        <div style="display: flex; flex-direction: column;" *ngIf="curRule.consistencyIssues && curRule.consistencyIssues.length > 0">
        
        <p class="phrase-rev-rule-ref-title">{{ "translate.rev.consistencyIssues" | translate }}:</p>
        
        <div class="phrase-rev-rule-ref-container" style="background-color: #fce9e8 !important">
        <div style="display:flex;" [ngStyle]="i > 0 ? { 'margin-top': '10px' } : {} " *ngFor="let consistencyIssue of curRule.consistencyIssues; let i = index"
        >
          <i class="priority-high" style="padding-top: 5px"
            ></i>
              <div style="flex:1; padding-top: 5px; padding-bottom: 5px; padding-left: 5px; padding-right: 5px;" >
                <p>
            {{ consistencyIssue.reason }}
                </p>
              </div>
                <a (click)="showConsistencyIssuesPhrases(consistencyIssue)" style="width: 40px; padding-top: 5px;">
                  {{ "translate.general.view" | translate }}
                </a> 
        </div>
        </div>
      
      </div>
    -->

      </div>

      <view-page-and-annotate-element *ngIf="showConsistencyIssuePhrases" 
      [embeddedObjectAnnotation]="currEmbeddedObjectAnnotation"
      (closePdfViewerEmitter)="showConsistencyIssuePhrases = false"></view-page-and-annotate-element>

      <div *ngIf="ruleCatMatches.length > 0 && isExpanded">
        <cat-match-phrase [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions" (revertConsistencyCheckResultEmitter)="revertConsistencyCheckResult(ruleCatMatches[currentIndex])" [catMatch]="ruleCatMatches[currentIndex]"></cat-match-phrase>
        <cat-match-phrase-metadata  [catMatch]="ruleCatMatches[currentIndex]" style="margin-top: 10px; display: block"> </cat-match-phrase-metadata>

      </div>
      
      <div *ngIf="ruleCatMatches.length == 0 && isExpanded && !loading" style="height: 100px !important" class="template-container">
        <h3>
          {{ "translate.rev.noMatchesFound" | translate }}
        </h3>
      </div>
    </div>

    <div [ngClass]="{
      'scrollable-grid': true,
      'phrase-rev-rule-container': ruleCatMatches.length > 0 && isExpanded}">

      <!-- <div class="suggested-references-full-row">
        <ng-container *ngTemplateOutlet="suggestedReferencesTemplate; context: {references: suggestedReferences, hideReferences: { toggleVisibility: hideSuggestedReferencesTable }, label: 'translate.general.suggested.references'  }"></ng-container> 
      </div> -->
      <div *ngIf="ruleCatMatches.length > 0 && isExpanded" class="suggested-references-row-spacer"></div>

      <ng-container *ngTemplateOutlet="referencesTemplate; context: { references: footnotes, hideReferences: { toggleVisibility: hideFootnotesTable }, referenceIssues: curRule.referenceIssues, label: 'translate.rev.footnotes', labelRightHandSide: 'translate.rev.footnotes.righthandSide', hasIssues: hasReferenceIssue(footnotes, true), isFootnotes: true }">
        
      </ng-container>  
      <ng-container *ngTemplateOutlet="referencesTemplate; context: { references: references, hideReferences: { toggleVisibility: hideReferencesTable }, referenceIssues: curRule.referenceIssues, label: 'translate.rev.reference', labelRightHandSide: 'translate.rev.reference.righthandSide', hasIssues: hasReferenceIssue(references, false), isFootnotes: false }">
        
      </ng-container>

          <ng-container *ngIf="!isAddAnchorsDisabled() && curRule && editable && !((references && references?.length > 0) || (anchorContext && anchorContext?.length > 0) || hasReferenceIssue(references, false))">
            <div style="margin-top:10px; margin-bottom: 10px">
              <a [class.disabled]="conditionForDisablingConsistencyCheckResultActions" (click)="toggleAddContextDropdown()" class="add-context-btn" style="cursor: pointer;">
                <i [class.disabled]="conditionForDisablingConsistencyCheckResultActions" [ngClass]="showAddContextDropdown.value ? 'fas fa-minus' : 'fas fa-plus'"></i>{{ "translate.cat.addReference" | translate }}
              </a>
              </div>
              <div></div>
          <ng-container *ngIf="showAddContextDropdown.value">
            <add-anchor [curDoc]="curDoc" [phrase]="curRule"
            (addedAnchor)="addedAnchor()"
            [disabled]="conditionForDisablingConsistencyCheckResultActions"
            [showAddContextDropdown]="showAddContextDropdown">

            </add-anchor>
            <div></div>
          </ng-container>
          </ng-container>

      <ng-container *ngIf="(curRule.associatedText && curRule.associatedText.length > 0) || hasAssociatedTextIssue()">
        <div style="display: flex">
          <ng-container *ngIf="curRule.fullyFetched else loadingSpinner">
            <span style="margin-right: 5px" class="circle-badge" [ngClass]="!hasAssociatedTextIssue() ? 'success' : (isFullMatch ? 'warning-info' : 'error')">
              <i [ngClass]="!hasAssociatedTextIssue() ? 'pi pi-check' : (isFullMatch ? 'pi pi-exclamation-triangle' : 'pi pi-times')"></i>
            </span>
          </ng-container>
          <a class="phrase-rev-rule-ref-title" (click)="hideAssociatedTextTable = !hideAssociatedTextTable">{{ "translate.general.associatedText" | translate }}
            <span [ngClass]="hideAssociatedTextTable ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
          </a>
        </div> 
        <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
          <p class="phrase-rev-rule-ref-title"></p>
        </ng-container>
        <ng-container *ngFor="let assocPhrase of curRule.associatedText; let i = index">
          <slide-in-out *ngIf="!hideAssociatedTextTable" [isOpen]="!hideAssociatedTextTable" [cssClass]="'accordionHeight'">
            <div class="phrase-rev-rule-ref-container">
              <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
                {{ assocPhrase.assocPhraseText }}
              </p>
              <div [ngClass]="{'ref-match-container': isExpanded && ruleCatMatches.length > 0 && getAssociatedTextFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)?.assocTextFinding === 'ADDED_ASSOC_TEXT'}">
                <div>
                  <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" class="text"
                    [phraseWords]="assocPhrase.phraseDispWords"></formatted-phrase>
                    <p class="ref-id">
                      {{ "translate.cat.phraseId" | translate }}: {{ assocPhrase.assocPhraseId }}
                    </p>
                </div>
                <div *ngIf="isExpanded && ruleCatMatches.length > 0 && getAssociatedTextFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)?.assocTextFinding === 'ADDED_ASSOC_TEXT'" class="ref-similarity-code">
                  <p class="extra">
                    {{ "translate.rev.refAdded" | translate }}
                  </p>
                </div>
              </div>
            </div>
          </slide-in-out>

          <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
            <slide-in-out *ngIf="!hideAssociatedTextTable" [isOpen]="!hideAssociatedTextTable" [cssClass]="'accordionHeight'">
            <div class="issues-column" style="height: 100%;">
              <ng-container *ngIf="getAssociatedTextFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)?.assocTextFinding === 'ADDED_ASSOC_TEXT'">
                <div class="ref missing-reference"></div>
              </ng-container>
              <ng-container>
                <ng-container *ngIf="!(getAssociatedTextFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)?.assocTextFinding === 'ADDED_ASSOC_TEXT')">
                  <cat-match-phrase-assoc-text class="ref" [associatedText]="assocPhrase" [mainPhrase]="ruleCatMatches[currentIndex].catPhrase"
                    [associatedTextFinding]="getAssociatedTextFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocPhrase.assocPhraseId)">
                  </cat-match-phrase-assoc-text>
                </ng-container>
              </ng-container>
            </div>
            </slide-in-out>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
          <ng-container *ngFor="let issue of getMissingAssocTextFinding(ruleCatMatches[currentIndex].catPhrase.phraseId)">
          <slide-in-out *ngIf="!hideAssociatedTextTable" [isOpen]="!hideAssociatedTextTable" [cssClass]="'accordionHeight missing-reference'">  
            <div class="reference-column">
              <div class="ref missing-reference"></div>
            </div>
          </slide-in-out>
          <slide-in-out *ngIf="!hideAssociatedTextTable" [isOpen]="!hideAssociatedTextTable" [cssClass]="'accordionHeight'">
            <div class="issues-column" style="height: 100%">
              <div class="phrase-rev-rule-ref-container">
                <div class="ref-match-container">
                  <div>
                    <p class="text">
                      {{ getCatPhraseAssocText(issue.catAssocPhraseId)?.assocPhraseText }}
                    </p>
                    <p class="ref-id">
                      {{ "translate.cat.phraseId" | translate }}: {{ issue.catAssocPhraseId }}
                    </p>
                  </div>
                  <div class="ref-similarity-code">
                    <p class="missing">
                      {{ "translate.rev.refMissing" | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            </slide-in-out>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngTemplateOutlet="imagesTemplate; context: {associatedImages: images, hideAssociatedImages: hideAssociatedImages, label: 'translate.general.associatatedImages', labelRightHandSide: 'translate.general.associatatedImages.righthandSide', hasIssues: hasAssociatedImagesIssue(images, false), isTables: false }" >

      </ng-container>
      <ng-container *ngTemplateOutlet="imagesTemplate; context: {associatedImages: tables, hideAssociatedImages: hideAssociatedTables, label: 'translate.general.associatedTables', labelRightHandSide: 'translate.general.associatedTables.righthandSide', hasIssues: hasAssociatedImagesIssue(tables, true), isTables: true }" >

      </ng-container>
      <ng-container *ngIf="curRule.referencedBy">
        <div>
        <p class="phrase-rev-rule-ref-title">{{ "translate.rev.referencedBy" | translate }}:</p>
        <p></p>
        <div *ngFor="let ref of curRule.referencedBy" class="phrase-rev-rule-ref-by-container">
          <p *ngIf="ref.phraseDispWords.length == 0" class="text">
            {{ ref.refPhraseText }}
          </p>
          <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" [phraseWords]="ref.phraseDispWords"
            class="text"></formatted-phrase>
        </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isPhrase && curRule.referencedBy"><div></div></ng-container>

      <ng-container *ngIf="curRule.associatedBy">
        <div>
        <p class="phrase-rev-rule-ref-title">{{ "translate.general.associatedBy" | translate }}:</p>
        <p></p>
        <div *ngFor="let assocPhrase of curRule.associatedBy" class="phrase-rev-rule-ref-by-container">
          <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
            {{ assocPhrase.assocPhraseText }}
          </p>
          <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" [phraseWords]="assocPhrase.phraseDispWords"
            class="text"></formatted-phrase>
        </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isPhrase && curRule.associatedBy"><div></div></ng-container>
    </div>
    <!-- promeniti uslov dodati staviti !isExpanded -->
    <div *ngIf="!isExpanded && !ruleCatMatches?.length > 0 && !loading">
      <div class="template-container">
        <h3>
          {{ "translate.rev.noMatchesFound" | translate }}
        </h3>
      </div>
    </div>

    <div class="l-align-spaceBetween">
      <div class="l-align-spaceBetween">
        <p [ngClass]="['rev-rule-type-descr', curRule.revRuleType]">
          {{ curRule.revRuleSimilarityEventDesc || curRule.revRuleTypeDescr }}
        </p>
        <p class="cat-phrase-type">
          &nbsp; &middot; {{ curRule.revRuleContentTypeDesc || curRule.similarityDescr }}
        </p>
      </div>

      <p-selectButton *ngIf="editable" [disabled]="conditionForDisablingRevStatusChanges" class="rev-status" [options]="ruleStatusOptions"
        [(ngModel)]="curRule.ruleUserStatus" (onChange)="onRevStatusChange()"></p-selectButton>
    </div>

    <div class="comment-container">
      <p class="t-footnote t-row--small">
        {{ "translate.general.comment" | translate }}
      </p>
      <textarea class="comment" tabindex="0" [disabled]="!editable" pTextarea [(ngModel)]="curRule.comment"
        autoResize="true" (ngModelChange)="dirtySw = true"></textarea>
    </div>

    <div>
      <ng-container *ngTemplateOutlet="formatMatchTemplate"></ng-container>

      <div *ngIf="curRule.revRuleType == 'SPELLING'">
        <ng-container *ngTemplateOutlet="spellingTemplate"></ng-container>
      </div>

      <div *ngIf="curRule.cardMatch">
        <ng-container *ngTemplateOutlet="cardMatchTemplate"></ng-container>
      </div>
    </div>

    <p class="footnote id">
      {{ "translate.rev.ruleId" | translate }}: {{ curRule.revRuleId }}
    </p>
    <!--<loader *ngIf="loading"></loader>-->
  </div>
</modal-popup>
  <ng-template #referencesTemplate let-isFootnotes="isFootnotes" let-hasIssues="hasIssues" let-label="label" let-labelRightHandSide="labelRightHandSide" let-references="references" let-hideReferences="hideReferences" let-referenceIssues="referenceIssues">

      <ng-container *ngIf="(references && references?.length > 0) || (!isFootnotes && anchorContext && anchorContext?.length > 0) || (hasIssues)">
        <div style="display: flex">
          <ng-container *ngIf="curRule.fullyFetched else loadingSpinner">
            <span style="margin-right: 5px" class="circle-badge" [ngClass]="!hasIssues ? 'success' : 'error'"><i [ngClass]="!hasIssues ? 'pi pi-check' : 'pi pi-times'"></i></span>
          </ng-container>

          <a class="phrase-rev-rule-ref-title" (click)="toggleVisibility(hideReferences)">{{ label | translate }}
            <span [ngClass]="hideReferences.toggleVisibility ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
          </a>
        </div> 
        <ng-container *ngIf="ruleCatMatches.length > 0 && isExpanded">
          <!-- <p class="phrase-rev-rule-ref-title">{{ "translate.rev.reference" | translate }}:</p> -->
           <div class="phrase-rev-rule-ref-title"><span *ngIf="!hideReferences.toggleVisibility">{{ labelRightHandSide | translate }}</span></div>
        </ng-container>
          <ng-container *ngIf="!isAddAnchorsDisabled() && editable && !hideReferences.toggleVisibility && !isFootnotes">
              <div style="margin-top:5px; margin-bottom: 5px;">
                <a [class.disabled]="conditionForDisablingConsistencyCheckResultActions" (click)="toggleAddContextDropdown()" class="add-context-btn" style="margin-left: 0.5rem; cursor: pointer;">
                  <i [class.disabled]="conditionForDisablingConsistencyCheckResultActions" [ngClass]="showAddContextDropdown.value ? 'fas fa-minus' : 'fas fa-plus'"></i>  {{ "translate.cat.addReference" | translate }}
                </a>
              </div>
              <div></div>
          </ng-container>
          <ng-container *ngFor="let ref of references; let i = index">
            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
            <div class="phrase-rev-rule-ref-container ref-with-view" [class.border-indicator-reference]="!isFootnotes">
              <p *ngIf="ref.phraseDispWords.length == 0 && ref.refPhraseText" class="text">
                {{ ref.refPhraseText }}
              </p>
              <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
                [phraseWords]="ref.phraseDispWords"></formatted-phrase>
              <p *ngIf="ref.phraseDispWords.length == 0 && !ref.refPhraseText && ref.anchors != null && ref.anchors.length > 0">
                {{ ref.anchors[0]?.embeddedObjectAnnotation?.docName }}
              </p>

              <div class="ref-view-action">
                <i *ngIf="canViewRefDoc(ref)"
                  style="cursor: pointer; color: #0978a2"
                  class="icon fa-solid fa-arrow-up-right-from-square"
                  [class.selected]="true"
                  [tooltip]="'translate.general.viewRefDoc' | translate"
                  (click)="viewRefDoc(ref)">
                </i>
              </div>
              @let refIssue = getReferenceIssue(ruleCatMatches[currentIndex]?.catPhrase?.phraseId, ref.refPhraseId);
              
              <div [ngClass]="{'ref-match-container': isExpanded && ruleCatMatches.length > 0 && (refIssue?.refFinding === 'ADDED_REFERENCE' || refIssue?.refFinding === 'ADDED_ANCHOR_REFERENCE')}">
                <div>
                  <ng-container *ngIf="ref.anchors != null && ref.anchors.length > 0">
                    <div>
<!--                       <div class="t-small" style="margin-top: 10px; margin-bottom: 10px">
                          <a (click)="toggleDisplayAnchors(ref)">
                            
                            <span [ngClass]="!ref.showAnchors ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
                          </a>
                      </div> -->

                        <mng-anchors style="margin-top: 10px" *ngIf="ref.showAnchors" [anchors]="ref.anchors"
                        (viewPageAndRef)="viewPageAndRef($event)"
                        [phrase]="curRule"
                        [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                        (anchorToRemove)="removeIssueEvent()"
                        (showRefDoc)="viewRefDoc(ref)"
                        (anchorPathChange)="onAnchorPathChange()"
                        >

                        </mng-anchors>
                      </div>
                    </ng-container>
                    
                  <ng-container *ngIf="!isAddAnchorsDisabled() && !isFootnotes && curRule">

                    @let anchorsExpanded = getShowAddAnchorForReferenceValue(ref.refPhraseId);
                    <a [class.disabled]="conditionForDisablingConsistencyCheckResultActions" class="btn btn-link" style="margin-left:0.5rem; cursor:pointer; font-size:0.85rem;" (click)="setShowAddAnchorForReference(ref.refPhraseId, !anchorsExpanded)">
                      <i [class.disabled]="conditionForDisablingConsistencyCheckResultActions" [ngClass]="anchorsExpanded ? 'fas fa-minus': 'fas fa-plus'"></i>
                      &nbsp;{{ ("translate.general.addAnchor" | translate) }}
                    </a>
                    <ng-container *ngIf="anchorsExpanded">
                      <add-anchor [curDoc]="curDoc" [phrase]="curRule" [reference]="ref"
                      [layoutClass]="'reference'"
                      (addedAnchor)="addedAnchor()"
                      [disabled]="conditionForDisablingConsistencyCheckResultActions"
                        [showAddContextDropdown]="getShowAddAnchorForReference(ref.refPhraseId)">

                      </add-anchor>
                    </ng-container>
                  </ng-container>
                    <div style="display: flex">
                      <p class="ref-id">
                        {{ "translate.cat.phraseId" | translate }}: {{ ref.refPhraseId }}
                      </p>
                  </div>
                </div>
                @let referenceIssue = getReferenceIssue(ruleCatMatches[currentIndex]?.catPhrase?.phraseId, ref.refPhraseId);
                <div *ngIf="isExpanded && ruleCatMatches.length > 0 && referenceIssue?.refFinding === 'ADDED_REFERENCE'" class="ref-similarity-code">
                  <p class="extra">
                    {{ "translate.rev.refAdded" | translate }}
                  </p>
                </div>
                <div *ngIf="isExpanded && ruleCatMatches.length > 0 && referenceIssue?.refFinding === 'ADDED_ANCHOR_REFERENCE'" class="ref-similarity-code">
                  <p class="missing-reference-anchor">
                    {{ "translate.rev.refMissingAnchorReference" | translate }}
                  </p>
                </div>
              </div>
            </div>
            </slide-in-out>

            <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
              <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight missing-reference'">
              <div class="issues-column" style="height: 100%" >
                <ng-container *ngIf="getReferenceIssue(ruleCatMatches[currentIndex].catPhrase.phraseId, ref.refPhraseId)?.refFinding === 'ADDED_REFERENCE'">
                  <div class="ref missing-reference"></div>
                </ng-container>
                <ng-container>
                  <ng-container *ngIf="!(getReferenceIssue(ruleCatMatches[currentIndex].catPhrase.phraseId, ref.refPhraseId)?.refFinding === 'ADDED_REFERENCE')">
                    <cat-match-phrase-ref class="ref" 
                    [ref]="ref"
                    [mainPhrase]="curRule"
                    [showBorderIndicator]="!isFootnotes"
                    [catPhrase]="ruleCatMatches[currentIndex].catPhrase" 
                    [refMatches]="ruleCatMatches[currentIndex].refMatch"
                    [referenceIssue]="getReferenceIssue(ruleCatMatches[currentIndex].catPhrase.phraseId, ref.refPhraseId)"
                    (anchorPathChange)="onAnchorPathChange()">
                    </cat-match-phrase-ref>
                  </ng-container>
                </ng-container>
              </div>
              </slide-in-out>
            </ng-container>
          </ng-container>
        <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
          <ng-container *ngFor="let issue of getMissingReferenceIssue(ruleCatMatches[currentIndex].catPhrase.phraseId, isFootnotes)">
            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight missing-reference'">
              <div class="reference-column">
                <div class="ref missing-reference"></div>
              </div>
            </slide-in-out>
            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
              @let catPhraseReference = getCatPhraseReference(issue?.catRefPhraseId);
              <div class="issues-column" style="height: 100%; position: relative;" [ngClass]="getBorderClass(catPhraseReference)">
                <div class="phrase-rev-rule-ref-container">
                  <div class="ref-match-container">
                    <div>
                      <p class="text">
                        {{ catPhraseReference?.refPhraseText }}
                      </p>
                          <mng-anchors style="margin-top: 10px"  [anchors]="catPhraseReference.anchors"
                          (viewPageAndRef)="viewPageAndRef($event)"
                          [phrase]="curRule"
                          [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                          (anchorToRemove)="removeIssueEvent()"
                          (showRefDoc)="viewRefDoc(catPhraseReference)"
                          (anchorPathChange)="onAnchorPathChange()"
                          [displayActions]="false"
                          [catMatchReference]="catPhraseReference"
                          [copyAnchors]="true"
                          [moveCopyButton]="false"
                          [isMissingInWorkingPhrase]="true"
                          [referenceIssue]="issue"
                          >
                          </mng-anchors>
                      <p class="ref-id">
                        {{ "translate.cat.phraseId" | translate }}: {{ issue.catRefPhraseId }}
                      </p>
                    </div>
                    <div style="display: flex; flex-direction: column;">
                      <div style="margin-right: 5px;" *ngIf="catPhraseReference.anchors != null && catPhraseReference.anchors.length > 0">
                          <copy-all-anchors [isMissingInWorkingPhrase]="true" 
                          [phrase]="curRule"
                          [copyAnchors]="true"
                          [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                          [catMatchReference]="catPhraseReference"
                          [catMatchRefAnchors]="catPhraseReference.anchors"
                          [isMissingInWorkingPhrase]="true"
                          [referenceIssue]="issue"
                          >

                          </copy-all-anchors>
                      </div>
                      <div class="ref-similarity-code">
                        <p class="missing">
                          {{ "translate.rev.refMissing" | translate }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide-in-out>
          </ng-container>
        </ng-container>
 
        <!-- Anchor context -->
         <ng-container *ngIf="!isFootnotes">
          <ng-container *ngFor="let ref of anchorContext; let i = index">
              
              @let anchorReferenceIssue = !(ruleCatMatches && ruleCatMatches.length > 0) ? null : getAnchorReferenceIssue(ruleCatMatches[currentIndex].catPhrase.phraseId, ref.refDocId);
              @let missingReferenceIssue = !(ruleCatMatches && ruleCatMatches.length > 0) ? null : getMissingAnchorReferenceIssue(ruleCatMatches[currentIndex].catPhrase.phraseId, ref.refDocId);

            <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
                <ng-container *ngTemplateOutlet="anchorReference; context: {ref: ref, editAnchors: true, isAddedInWorkingPhrase: (ruleCatMatches && ruleCatMatches.length > 0) && (!anchorReferenceIssue && !missingReferenceIssue)}"></ng-container>
            </slide-in-out>
            <ng-container *ngIf="isExpanded">

              <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility"
                [cssClass]="'accordionHeight'">   
                  <div style="height: 100% !important"
                  *ngIf="anchorReferenceIssue; else checkReferenceIssue">
                        <ng-container *ngTemplateOutlet="anchorReference; context: { ref: anchorReferenceIssue, editAnchors: false, matchedRef: ref }"></ng-container>

                  </div>

                  <ng-template #checkReferenceIssue>
                  <div style="height: 100% !important"
                    *ngIf="missingReferenceIssue; else missingAnchorInCat">
                      <cat-match-phrase-ref class="ref"
                      [ref]="ref"
                      [mainPhrase]="curRule"
                      [showBorderIndicator]="true"
                      [catPhrase]="ruleCatMatches[currentIndex].catPhrase"
                      [refMatches]="ruleCatMatches[currentIndex].refMatch"
                      [referenceIssue]="missingReferenceIssue"
                      (anchorPathChange)="onAnchorPathChange()">

                      </cat-match-phrase-ref>
                  </div>
                  </ng-template>
              </slide-in-out>
            </ng-container>
              <ng-template #missingAnchorInCat>
                    <div class="missing-anchor-context">
                    </div>
              </ng-template>
          </ng-container>
          <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0 && catMatchAnchorContext.length > 0">
              <ng-container *ngFor="let catMatchAnchorReference of catMatchAnchorContext">
                <ng-container *ngIf="getMissingCatMatchAnchorContext(catMatchAnchorReference)">
                  <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
                    <div class="missing-anchor-context">
                    </div>
                  </slide-in-out>
                  <slide-in-out *ngIf="!hideReferences.toggleVisibility" [isOpen]="!hideReferences.toggleVisibility" [cssClass]="'accordionHeight'">
                    <div class="issues-column border-indicator-anchor" style="height: 100%">
                      <div class="phrase-rev-rule-ref-container">
                        <div class="ref-match-container" style="display: flex; flex-direction: column;">
                          <div style="display: flex;">
                            
                            <div>
                              <p class="text">
                              {{ catMatchAnchorReference?.refPhraseText }}
                              </p>
                            </div>
                            <div style="margin-left: auto; display: flex; align-items: center;">
                              <div style="margin-right: 5px;" *ngIf="catMatchAnchorReference.anchors != null && catMatchAnchorReference.anchors.length > 0">
                                <copy-all-anchors [isMissingInWorkingPhrase]="true" 
                                [phrase]="curRule"
                                [copyAnchors]="true"
                                [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                                [catMatchReference]="catMatchAnchorReference"
                                [catMatchRefAnchors]="catMatchAnchorReference.anchors"

                                >

                                </copy-all-anchors>
                              </div>
                              <i *ngIf="canViewRefDoc(catMatchAnchorReference)"
                                style="cursor: pointer; color: #0978a2;"
                                class="icon fa-solid fa-arrow-up-right-from-square"
                                [class.selected]="true"
                                [tooltip]="'translate.general.viewRefDoc' | translate"
                                (click)="viewRefDoc(catMatchAnchorReference)">
                              </i>
                            </div>
                          </div>
                          <mng-anchors style="margin-top: 10px"  [anchors]="catMatchAnchorReference.anchors"
                          (viewPageAndRef)="viewPageAndRef($event)"
                          [phrase]="curRule"
                          [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                          (anchorToRemove)="removeIssueEvent()"
                          (showRefDoc)="viewRefDoc(catMatchAnchorReference)"
                          (anchorPathChange)="onAnchorPathChange()"
                          [displayActions]="false"
                          [copyAnchors]="true"
                          [catMatchReference]="catMatchAnchorReference"
                          [isMissingInWorkingPhrase]="true"
                          [moveCopyButton]="false"
                          >
                          </mng-anchors>
                          <div class="anchor-context-issue-label">
                            <p class="missing">
                              {{ "translate.rev.refMissing" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide-in-out>
              </ng-container>
              </ng-container>
          </ng-container>
          <ng-template #anchorReference let-ref="ref" let-editAnchors="editAnchors" let-matchedRef="matchedRef" let-isAddedInWorkingPhrase="isAddedInWorkingPhrase">
              <div class="phrase-rev-rule-ref-container ref-with-view" [ngClass]="getBorderClass(ref)">
                <p *ngIf="ref.phraseDispWords.length == 0 && ref.refPhraseText" class="text">
                  {{ ref.refPhraseText }}
                </p>
                <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
                  [phraseWords]="ref.phraseDispWords"></formatted-phrase>
                <p *ngIf="ref.phraseDispWords.length == 0 && !ref.refPhraseText && ref.anchors != null && ref.anchors.length > 0">
                  {{ ref.anchors[0]?.embeddedObjectAnnotation?.docName }}
                </p>

                <div class="ref-view-action" style="align-items: center;">
<!--                   <div *ngIf="!editAnchors && matchedRef && ref.anchors != null && ref.anchors.length > 0" class="copy-button" style="margin-right: 5px;">
                      <a  class="icon" [class.disabled]="!(canCopyAnchors | async)" (click)="copyNotExistingAnchors()">
                          
                        <i class="fa-regular fa-circle-left" [title]="'translate.general.copyAnchors' | translate" [class.disabled]="!(canCopyAnchors | async)"></i>
                      </a>
                  </div> -->
                <div *ngIf="!editAnchors && matchedRef && ref.anchors != null && ref.anchors.length > 0" style="margin-right: 5px;">
                  <copy-all-anchors [catMatchRefAnchors]="ref.anchors"
                  [workingRefAnchors]="matchedRef.anchors"
                  [phrase]="curRule"
                  [disableConsistencyCheckResultsActions]="conditionForDisablingConsistencyCheckResultActions"
                  [copyAllAnchors]="setDirtyFlags()"
                  [copyAnchors]="true">

                  </copy-all-anchors>
                </div>

                  <i *ngIf="canViewRefDoc(ref)"
                    style="cursor: pointer; color: #0978a2"
                    class="icon fa-solid fa-arrow-up-right-from-square"
                    [class.selected]="true"
                    [tooltip]="'translate.general.viewRefDoc' | translate"
                    (click)="viewRefDoc(ref)">
                  </i>
                </div>
                
                <div [ngClass]="{'ref-match-container': isExpanded}">
                  <div>
                    <ng-container *ngIf="ref.anchors != null && ref.anchors.length > 0">
                      <div>
                          <mng-anchors style="margin-top: 10px" *ngIf="ref.showAnchors" [anchors]="ref.anchors"
                          (viewPageAndRef)="viewPageAndRef($event)"
                          [phrase]="curRule"
                          [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                          (anchorToRemove)="removeIssueEvent()"
                          (showRefDoc)="viewRefDoc(ref)"
                          (anchorPathChange)="onAnchorPathChange()"
                          [displayActions]="editAnchors"
                          [copyAnchors]="!editAnchors && matchedRef"
                          [workingRefAnchors]="matchedRef?.anchors">
                          </mng-anchors>
                        </div>
                      </ng-container>
                  <ng-container *ngIf="!isAddAnchorsDisabled() && !isFootnotes && curRule && editAnchors">

                    @let anchorsExpanded = getShowAddAnchorForReferenceValue(ref.refPhraseId);
                    <a [class.disabled]="conditionForDisablingConsistencyCheckResultActions" class="btn btn-link" style="margin-left:0.5rem; cursor:pointer; font-size:0.85rem;" (click)="setShowAddAnchorForReference(ref.refPhraseId, !anchorsExpanded)">
                      <i [class.disabled]="conditionForDisablingConsistencyCheckResultActions" [ngClass]="!anchorsExpanded ? 'fas fa-plus' : 'fas fa-minus'"></i>
                      &nbsp;{{ ("translate.general.addAnchor" | translate) }}
                    </a>
                    <ng-container *ngIf="anchorsExpanded">
                      <add-anchor [curDoc]="curDoc" [phrase]="curRule" [reference]="ref"
                      [layoutClass]="'reference'"
                      (addedAnchor)="addedAnchor()"
                      [disabled]="conditionForDisablingConsistencyCheckResultActions"
                        [showAddContextDropdown]="getShowAddAnchorForReference(ref.refPhraseId)">

                      </add-anchor>
                    </ng-container>
                  </ng-container>
                      <div *ngIf="ref.refPhraseId && !ref.isConsistencyGenerated" style="display: flex">
                        <p class="ref-id">
                          {{ "translate.cat.phraseId" | translate }}: {{ ref.refPhraseId }}
                        </p>
                    </div>
                  </div>
                </div>
                  <div *ngIf="isAddedInWorkingPhrase" class="anchor-context-issue-label">
                    
                    {{ "translate.rev.refAdded" | translate }}
                  </div>
              </div>

          </ng-template>

         </ng-container>  

        <ng-container *ngIf="!isFootnotes && curRule && curRule.phraseId && showAddContextDropdown.value && !hideReferences.toggleVisibility" >      
          <add-anchor [curDoc]="curDoc" [phrase]="curRule"
          (addedAnchor)="addedAnchor()"
          [disabled]="conditionForDisablingConsistencyCheckResultActions"
            [showAddContextDropdown]="showAddContextDropdown">

          </add-anchor>
          <div></div>
        </ng-container>
      </ng-container>

</ng-template>
<ng-template #imagesTemplate  let-isTables="isTables" let-associatedImages="associatedImages" let-hideAssociatedImages="hideAssociatedImages" let-hasIssues="hasIssues" let-label="label" let-labelRightHandSide="labelRightHandSide">
      <ng-container *ngIf="(associatedImages && associatedImages.length > 0) || hasIssues">
        <div style="display: flex">
          <ng-container *ngIf="curRule.fullyFetched else loadingSpinner">
            <span style="margin-right: 5px" class="circle-badge" [ngClass]="!hasIssues ? 'success' : (isFullMatch ? 'warning-info' : 'error')">
              <i [ngClass]="!hasIssues ? 'pi pi-check' : (isFullMatch ? 'pi pi-exclamation-triangle' : 'pi pi-times')"></i>
            </span>
          </ng-container>
          <a class="phrase-rev-rule-ref-title" (click)="toggleAssociatedImages(hideAssociatedImages)">{{ label | translate }}
            <span [ngClass]="(hideAssociatedImages | async) ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>
          </a>
        </div>        
        <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
          <p class="phrase-rev-rule-ref-title"><span *ngIf="!(hideAssociatedImages | async)">{{ labelRightHandSide | translate}}</span></p>
        </ng-container>

        <ng-container *ngFor="let assocImg of associatedImages">
          <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight'">
          <div class="t-row--med" style="height: 100%;" #assocImagesDivs [attr.data-id]="assocImg.assocImageId">
            <div class="phrase-rev-rule-ref-container">
              <div>
                <async-img [className]="associatedImagesClassName" *ngIf="assocImg.imgS3Key"  [url]="assocImg.imgUrl"></async-img>
                <!--// broj-->
            <ng-container *ngIf="assocImg.consistencyIssues && assocImg.consistencyIssues.length > 0">
              <div style="display:flex; margin-top: 10px; margin-right: 5px">
                <span style="margin-right: 5px" class="circle-badge error">{{ assocImg.consistencyIssues.length }}</span>
                <a class="phrase-rev-rule-ref-title" (click)="assocImg.hideConsistencyIssuesTable = !assocImg.hideConsistencyIssuesTable">
                  {{ "translate.general.consistencyIssues" | translate }}
                  <span [ngClass]="assocImg.hideConsistencyIssuesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
            <slide-in-out *ngIf="!assocImg.hideConsistencyIssuesTable" [isOpen]="!(hideAssociatedImages | async)">
              <div class="phrase-rev-rule-ref-container" style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
                <consistency-issues [consistencyIssues]="assocImg.consistencyIssues"
                    [element]="curRule"
                    [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                    (viewConsistencyIssueEmitter)="viewConsistencyIssue($event)"
                    (removeConsistencyIssueEmitter)="removeIssueEvent()"
                    (markConsistencyIssueAsConsistent)="removeIssueEvent()"
                    >

              </consistency-issues>
              <p style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                <ai-icon></ai-icon>
              </p>
              </div>
            </slide-in-out>
            </ng-container>
                <p class="ref-id">
                  {{ "translate.general.id" | translate }}: {{ assocImg.assocImageId }}
                </p>
              </div>
            </div>
          </div>
          </slide-in-out>

          <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
            <slide-in-out  *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight'">
            <div class="issues-column" style="height: 100%;">
              <ng-container *ngIf="getAssociatedImageFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocImg.assocImageId)?.assocImageFinding === 'ADDED_ASSOC_IMAGE'">
                <div class="ref ref-match-container missing-reference" style="direction: rtl; padding-right: 0.5rem;">
                  <div class="ref-similarity-code">
                    <p class="extra">
                      {{ "translate.rev.refAdded" | translate }}
                    </p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!(getAssociatedImageFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocImg.assocImageId)?.assocImageFinding === 'ADDED_ASSOC_IMAGE')">
                <cat-match-phrase-assoc-image class="ref" [associatedImage]="assocImg" [mainPhrase]="ruleCatMatches[currentIndex].catPhrase"
                  [associatedImageFinding]="getAssociatedImageFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, assocImg.assocImageId)">
                </cat-match-phrase-assoc-image>
              </ng-container>
            </div>
            </slide-in-out>
          </ng-container>

        </ng-container>

        <ng-container *ngIf="isExpanded && ruleCatMatches.length > 0">
          <ng-container *ngFor="let issue of getMissingAssocImageFinding(ruleCatMatches[currentIndex].catPhrase.phraseId, isTables)">
            <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight missing-reference'">
            <div class="reference-column">
              <div class="ref missing-reference"></div>
            </div>
            </slide-in-out>
            <slide-in-out *ngIf="!(hideAssociatedImages | async)" [isOpen]="!(hideAssociatedImages | async)" [cssClass]="'accordionHeight'">
            <div class="issues-column" style="height: 100%;">
              <div class="phrase-rev-rule-ref-container">
                <div class="ref-match-container">
                  <div>
                    <async-img *ngIf="getCatPhraseAssocImage(issue.catAssocImageId).imgS3Key" [className]="imageClassName" [url]="getCatPhraseAssocImage(issue.catAssocImageId).imgUrl"></async-img>
                    <p class="ref-id">
                      {{ "translate.general.id" | translate }}: {{ issue.catAssocImageId }}
                    </p>
                  </div>
                  <div class="ref-similarity-code">
                    <p class="missing">
                      {{ "translate.rev.refMissing" | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            </slide-in-out>
          </ng-container>
        </ng-container>

      </ng-container>
</ng-template>
<ng-template #suggestedReferencesTemplate let-references="references" let-label="label"
  let-hideReferences="hideReferences">
  <ng-container *ngIf="references && references.length > 0">
    <div style="display: flex">
      <span style="margin-right: 5px" class="circle-badge success"><i class="pi pi-check"></i></span>
      <a class="phrase-rev-rule-ref-title" (click)="toggleVisibility(hideReferences)">{{ label | translate }}
        <span [ngClass]="hideReferences.toggleVisibility ? 'pi pi-angle-down' : 'pi pi-angle-up'"
          style="margin-left: 0.3em;"></span>
      </a>
    </div>
    <div></div>
    <slide-in-out *ngIf="references && references.length > 0" [isOpen]="hideReferences?.toggleVisibility === false">
      <ng-container *ngFor="let ref of references; let i = index">
        <div class="phrase-rev-rule-ref-container">
          <p *ngIf="ref.phraseDispWords.length == 0 && ref.refPhraseText" class="text">
            {{ ref.refPhraseText }}
          </p>
          <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
            [phraseWords]="ref.phraseDispWords"></formatted-phrase>
          <p *ngIf="ref.phraseDispWords.length == 0 && !ref.refPhraseText && ref.anchors != null && ref.anchors.length > 0">
            {{ ref.anchors[0]?.embeddedObjectAnnotation?.docName }}
          </p>
          <ng-container *ngIf="ref.anchors != null && ref.anchors.length > 0">
            <div>
<!--               <div class="t-small" style="margin-top: 10px; margin-bottom: 10px">
                <a (click)="toggleDisplayAnchors(ref)">
                    
                  <span [ngClass]="!ref.showAnchors ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span> 

                </a>
              </div> -->

              <mng-anchors style="margin-top: 10px" *ngIf="ref.showAnchors"
                [anchors]="ref.anchors" (viewPageAndRef)="viewPageAndRef($event)"
                [phrase]="curRule" (anchorToRemove)="removeIssueEvent()"
                [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                (anchorPathChange)="onAnchorPathChange()">

              </mng-anchors>
            </div>
          </ng-container>
          <div>
            <p class="ref-id">
              {{ "translate.cat.phraseId" | translate }}: {{ ref.refPhraseId }}
            </p>
          </div>

        </div>
        <div></div>
      </ng-container>
    </slide-in-out>
  </ng-container>

</ng-template>
<ng-template #spellingTemplate>
  <div class="template-container">
    <h3>{{ "translate.rev.suggestedFix" | translate }}</h3>
    <p class="template-phrase-txt">
      <span *ngFor="let word of curRule.ruleDiffParts">{{ word.text }}</span>
    </p>
  </div>
</ng-template>

<ng-template #cardMatchTemplate>
  <card-match [cardMatch]="curRule.cardMatch"></card-match>
</ng-template>

<ng-template #formatMatchTemplate>
  <div *ngIf="formatMatchEntry.length" class="template-container">
    <div class="l-align-spaceBetween">
      <h3>
        {{ "translate.general.formatMatch" | translate }}
      </h3>
    </div>

    <div class="template-phrase-txt">
      <formatted-phrase [phraseWords]="formatMatchEntry" [formatType]="'formatMatchEntry'"
        [formatMatchDifferences]="formatMatchDifferences" [highlightedIds]="highlightedIds"
        (highlightedIdsChange)="highlightDiff($event)"></formatted-phrase>
    </div>

    <div class="diff-container">
      <div class="diff-title">
        <i class="fas fa-not-equal"></i>
        &nbsp; &nbsp;
        <p>{{ "translate.general.diff" | translate }}</p>
      </div>
      <p class="template-phrase-txt">
        <formatted-phrase [phraseWords]="formatMatchPhrase" [formatType]="'formatMatchPhrase'"
          [formatMatchDifferences]="formatMatchDifferences" [highlightedIds]="highlightedIds"
          (highlightedIdsChange)="highlightDiff($event)"></formatted-phrase>
      </p>
    </div>
    <table class="diffTable">
      <thead>
        <tr>
          <th>Phrase</th>
          <th>
            <i class="fas fa-not-equal"></i>&nbsp; &nbsp;{{ "translate.general.diff" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr [class.diffRowHighlight]="isHighlighted(difference.ids)" *ngFor="let difference of formatMatchDifferences"
          (mouseenter)="highlightDiff(difference.ids)" (mouseleave)="clearHighlight()">
          <td><span [tooltip]="difference.text">{{ difference.text | truncate:6:'...' }}</span></td>
          <td>
            <ng-container *ngFor="let attr of difference | keyvalue">
              <div class="diffItem" *ngIf="attr.key !== 'text' && attr.key !== 'ids'">
                <span class="diffTag">{{ getFriendlyDifferenceName(attr.key) }}</span>
                <span class="diffContent" [ngSwitch]="attr.key">
                  <ng-container *ngSwitchCase="'font_size'">
                    {{ attr.value[0] }} -> {{ attr.value[1] }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'font_name'" style="font-size: 0.6em">
                    {{ getFriendlyFontName(attr.value[0]) }} -> {{ getFriendlyFontName(attr.value[1]) }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'color_hex'">
                    <span class="color-box" [tooltip]="'Hex Color Code: ' + attr.value[0]"
                      [style.background-color]="attr.value[0]"></span> &nbsp; -> &nbsp;
                    <span class="color-box" [tooltip]="'Hex Color Code: ' + attr.value[1]"
                      [style.background-color]="attr.value[1]"></span>
                  </ng-container>
                  <ng-container *ngSwitchDefault style="font-family: 'Arial', sans-serif; font-weight: bolder;">
                    {{ attr.value[0].toLowerCase() === 'true' ? '✓' : '✗' }} -> {{ attr.value[1].toLowerCase() ===
                    'true' ? '✓' : '✗' }}
                  </ng-container>
                </span>
              </div>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</ng-template>

<ng-template #dirtyBtns>
  <!-- izbaciti ruleCatMatches.length > 0 iz uslova - uvek prikazivati -->
      <div style="display: flex; align-items: end;">
            <span 
      [ngClass]="isExpanded ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right'" 
      (click)="toggle()"
      [title]="(isExpanded ? 'translate.collapse.cat-matches': 'translate.expand.cat-matches') | translate"
      style="cursor: pointer; font-size: 1.2rem;"
    ></span>
      <reeval-status-icon [target]="reevalTarget" (refresh)="onReevalRefresh()"></reeval-status-icon>
      </div>
  <div *ngIf="dirtySw || dirtyConsistencyCheckResultsSw || hasWhitelistedWords()" class="t-small">
    <button class="t-button t-button-warn" [disabled]="loading" (click)="onSaveClickedPreProcessing()">
      {{ "translate.general.saveChanges" | translate }}
    </button>
    &nbsp;
    <button class="t-button-outline t-button-warn" [disabled]="loading" (click)="discardChanges()">
      {{ "translate.general.discardChanges" | translate }}
    </button>
  </div>
  <div class="l-align-center" *ngIf="hasPrev">
    <span [title]="('translate.prev.navigate-rules' | translate)" class="pi pi-chevron-up prev"(click)="showPrevRule()" style="position: absolute; 
    left: 50%; transform: translateX(-50%); color: black"></span>


  </div>
</ng-template>
<ng-template #footer>
  <div class="l-align-spaceBetween" *ngIf="hasNext">
    <span [title]="('translate.next.navigate-rules' | translate)" class="pi pi-chevron-down next" (click)="showNextRule()"></span>


  </div>
</ng-template>

<ng-template #loadingSpinner>
    <spinner style="margin-right: 5px" class="rev-rule-status-spinner"></spinner>
</ng-template>

<modal-popup
  *ngIf="refDocToView != null"
  [flexible]="false"
  [hideHeader]="false"
  [title]="refDocToView.docName"
  [isOpen]="refDocToView != null"
  (onClose)="refDocToView = null"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="refDocToView"
      [initialPage]="1"
      [displayDrawMode]="false"
      [displayToggleBoundingBoxes]="false"
      [singlePage]="false"
    ></pdf-viewer>
  </div>
</modal-popup>